import { render, staticRenderFns } from "./InsightsDisplay.vue?vue&type=template&id=598589ec&scoped=true"
import script from "./InsightsDisplay.vue?vue&type=script&lang=js"
export * from "./InsightsDisplay.vue?vue&type=script&lang=js"
import style0 from "./InsightsDisplay.vue?vue&type=style&index=0&id=598589ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598589ec",
  null
  
)

export default component.exports